import React from 'react'
import { ArrowCounterclockwise, Trash3, XCircleFill } from 'react-bootstrap-icons'

import { PartImage } from '../../../types/part/partTypes'
import ImageRotateControls from '../ImageRotateControls/ImageRotateControls'
import OverlayWithText from '../OverlayWithText/OverlayWithText'

import styles from './styles.module.scss'

interface IProps {
    id: string
    publicUrl: string
    previewAngle: number
    isSaving?: boolean
    markImg?: (id: string) => void
    unmarkImg?: (id: string) => void
    index: number
    setActiveImageIndex: (index: number) => void
    onRotate: (imageId: string) => void
}

const ModalImageThumb = ({
    id,
    publicUrl,
    previewAngle,
    isSaving = false,
    markImg,
    unmarkImg,
    index,
    setActiveImageIndex,
    onRotate,
}: IProps) => {
    const [isToDelete, setIsToDelete] = React.useState(false)

    return (
        <div className={styles.wrap}>
            <ImageRotateControls
                previewAngle={previewAngle}
                isDisabled={isSaving}
                onRotate={() => onRotate(id)}
            >
                <img
                    src={publicUrl}
                    alt=""
                    onClick={() => {
                        setActiveImageIndex(index)
                    }}
                />
            </ImageRotateControls>
            {markImg &&
                (!isToDelete ? (
                    <button
                        onClick={() => {
                            markImg && markImg(id)
                            setIsToDelete(true)
                        }}
                        className={styles.deleteButton}
                    >
                        <div>
                            <div className={styles.iconFill} />
                            <XCircleFill color="grey" size={14} />
                        </div>
                    </button>
                ) : (
                    <OverlayWithText backgroundBootstrapColor={'bg-danger'}>
                        <Trash3 color="white" size={40} />
                        <button
                            onClick={() => {
                                unmarkImg && unmarkImg(id)
                                setIsToDelete(false)
                            }}
                            className={styles.revertButton}
                        >
                            <ArrowCounterclockwise color="white" size={10} />
                        </button>
                    </OverlayWithText>
                ))}
        </div>
    )
}

export default ModalImageThumb
